"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/Username/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');
var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);
var _reactrouterdom = require('react-router-dom');

var _event = require('shared/services/event');
var _login = require('shared/validation/login');
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);

var _AuthFrame = require('web/components/AuthFrame');
var _Form = require('web/components/Form');
var _PasswordInput = require('web/components/PasswordInput'); var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
var _components = require('web/screens/Login/components');

var _PatientPanel = require('./PatientPanel'); var _PatientPanel2 = _interopRequireDefault(_PatientPanel);














const errorsMap = {
  // A phone number whose password matches more than one account can't pick
  // one of them; the email can.
  "Phone On Several Accounts": "This number is on more than one account. Sign in with your email.",
  "Pending Org": "Sorry, you won't be able to log in until your site administrator approves your account.",
  "Unverified Email": "Your email isn't verified yet. Check your inbox for a message that will let you verify it and try logging in again.",
}

// A wrong password and an unknown email get the same sentence, so the page
// never says whether an account exists.
 const INCORRECT_CREDENTIALS_MSG = "Incorrect email or password."; exports.INCORRECT_CREDENTIALS_MSG = INCORRECT_CREDENTIALS_MSG

const isKnownError = (err) =>
  typeof err === 'string' && err in errorsMap

const roleSegments = [
  { value: 'provider' , label: 'Provider' },
  { value: 'patient' , label: 'Patient' },
]

const UsernameLogin = ({
  onUsernameLogin,
  forgotPasswordRoute,
  isQuickLoginAvailable,
  gotoQuickLogin,
  gotoExpiredPassword,
  prefilledEmail,
  role: controlledRole,
  onRoleChange,
}) => {
  const [ownRole, setOwnRole] = _react.useState('provider')
  const role = _nullishCoalesce(controlledRole, () => ( ownRole))
  const setRole = _nullishCoalesce(onRoleChange, () => ( setOwnRole))
  const [loginError, setLoginError] = _react.useState(null)

  // The button stays enabled: a browser's autofill may not fire change
  // events until the page is touched. A field's error shows once they leave
  // it after typing, or on submit, and never while they type.
  const { control, register, handleSubmit, formState } =
    _reacthookform.useForm({
      resolver: _login.loginResolver,
      mode: 'onTouched',
      defaultValues: { email: prefilledEmail },
    })
  const { isSubmitting } = formState
  const display = _useFieldErrorDisplay2.default.call(void 0, { email: formState.errors.email, password: formState.errors.password })

  const submit = async (data, e) => {
    _optionalChain([e, 'optionalAccess', _ => _.preventDefault, 'call', _2 => _2()])
    setLoginError(null)
    return onUsernameLogin(data.email, data.password)
      .catch(e => {
        if (_optionalChain([e, 'access', _3 => _3.response, 'optionalAccess', _4 => _4.Error]) === 'Expired Password') {
          return gotoExpiredPassword('email-sent')
        }
        if (_optionalChain([e, 'access', _5 => _5.response, 'optionalAccess', _6 => _6.Error]) === 'Expired Password No Email') {
          return gotoExpiredPassword('no-email')
        }
        const code = _optionalChain([e, 'access', _7 => _7.response, 'optionalAccess', _8 => _8.Error])
        setLoginError(isKnownError(code) ? code : 'incorrect')
      })
  }

  return (
    _react2.default.createElement(_components.FormWrapper, {
      title: _react2.default.createElement(_react2.default.Fragment, null, "Sign in" , _react2.default.createElement('span', { className: "blmh-mobile-hide", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, " to BloomText"  )), __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}

      , _react2.default.createElement(_AuthFrame.SegmentedControl, {
        label: "Sign in as"  ,
        idPrefix: "login-role",
        segments: roleSegments,
        value: role,
        onChange: setRole, __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
      )
      , _react2.default.createElement('div', {
        className: "auth-stack",
        role: "tabpanel",
        id: "login-role-panel-patient",
        'aria-labelledby': "login-role-tab-patient",
        hidden: role !== 'patient', __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}

        , _react2.default.createElement(_PatientPanel2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 111}} )
      )
       /* The provider form stays mounted, so a typed email survives a trip to the Patient side. */ 
      , _react2.default.createElement('div', {
        className: "auth-stack",
        role: "tabpanel",
        id: "login-role-panel-provider",
        'aria-labelledby': "login-role-tab-provider",
        hidden: role !== 'provider', __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}

        , _react2.default.createElement('form', { onSubmit: handleSubmit(submit, errs => display.onSubmitErrors(Object.keys(errs))), noValidate: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
          , _react2.default.createElement(_Form.InputSection, {
            title: "Work email" ,
            inputType: "email",
            autoFocus: true,
            autoComplete: "username",
            placeholder: "name@clinic.com",
            errorMessage: _optionalChain([display, 'access', _9 => _9.shown, 'call', _10 => _10('email'), 'optionalAccess', _11 => _11.message]),
            inputProps: display.bind(register('email')), __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
          )
          , _react2.default.createElement(_Form.InputSectionWrapper, {
            title: "Password",
            errorMessage: _optionalChain([display, 'access', _12 => _12.shown, 'call', _13 => _13('password'), 'optionalAccess', _14 => _14.message]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}

            , _react2.default.createElement(_reacthookform.Controller, {
              name: "password",
              control: control,
              render: ({ field }) => (
                _react2.default.createElement(_PasswordInput2.default, {
                  inputId: "password",
                  autoComplete: "current-password",
                  placeholder: "Password",
                  hasError: !!display.shown('password') || !!loginError,
                  value: field.value,
                  onChange: (_id, value) => {
                    display.onType('password')
                    field.onChange(_event.makeChangeEvent.call(void 0, value))
                  },
                  onBlur: () => {
                    display.onLeave('password', field.value)
                    field.onBlur()
                  }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
                )
              ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
            )
          )
          ,  loginError === 'incorrect' && (
            _react2.default.createElement(_AuthFrame.Callout, {
              message: exports.INCORRECT_CREDENTIALS_MSG,
              actions: (
                _react2.default.createElement(_reactrouterdom.Link, { to: _routes2.default.WELCOME, className: "auth-chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}, "Create a staff account"

                )
              ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}
            )
          )
          ,  loginError && loginError !== 'incorrect' && (
            _react2.default.createElement(_AuthFrame.Callout, { message: errorsMap[loginError], __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}} )
          )
          , _react2.default.createElement(_Form.Button, {
            isSubmit: true,
            isLoading: isSubmitting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}
, "Log in"

          )
          , _react2.default.createElement('div', { className: "auth-links", __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
            , _react2.default.createElement(_reactrouterdom.Link, { to: forgotPasswordRoute, className: "auth-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}, "Forgot password?" )
            ,  isQuickLoginAvailable &&
              _react2.default.createElement('button', { type: "button", className: "auth-link", onClick: gotoQuickLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}, "Log in with PIN code"

              )
            
          )
        )
      )
    )
  )
}

exports. default = UsernameLogin
